export function importKicker(job) {
  const type = (job?.sourceType || '').toUpperCase();
  if (type === 'URL') return 'Web article import';
  if (type === 'TEXT') return 'Pasted text import';
  if (type === 'PDF') return 'PDF import';
  return 'Content import';
}

export function importTitleInProgress(job) {
  const type = (job?.sourceType || '').toUpperCase();
  if (type === 'URL') return 'Processing web article';
  if (type === 'TEXT') return 'Processing pasted text';
  if (type === 'PDF') return 'Processing PDF';
  return 'Processing import';
}

export function importSubtitle(job) {
  const parts = [];
  if (job?.sourceLabel) parts.push(job.sourceLabel);
  if (job?.sourceUrl) {
    try {
      const host = new URL(job.sourceUrl).hostname;
      parts.push(host);
    } catch {
      parts.push(job.sourceUrl.slice(0, 48));
    }
  } else if (job?.sourceFilename) {
    parts.push(job.sourceFilename);
  }
  return parts.join(' · ') || 'Generating questions from your material';
}

export function importFootnote(job) {
  const type = (job?.sourceType || '').toUpperCase();
  if (type === 'URL') {
    return 'We fetch the article, split it into sections, and generate Q&A from each part. Long articles may take a few minutes.';
  }
  if (type === 'TEXT') {
    return 'Text is split into sections and processed in the background.';
  }
  return 'Large documents may take several minutes while we extract text and generate Q&A.';
}
